import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FileTextIcon, CheckCircleIcon, AlertCircleIcon, ShieldIcon, BookOpenIcon, InfoIcon, CheckIcon, XIcon, ArrowRightIcon, ClipboardCheckIcon, FileTextIcon as FileTextIcon2 } from 'lucide-react';
import Card from '../components/Card';
import Button from '../components/Button';
const ShariahReviewPage = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('contract');
  const [complianceStatus, setComplianceStatus] = useState<'pending' | 'approved' | 'rejected'>('pending');
  const [showConfirmation, setShowConfirmation] = useState(false);
  // Mock data based on ID
  const applicationData = {
    id: `#SR${id}`,
    business: id === '1046' ? 'Amani Cafe' : 'GreenTech Solutions',
    type: id === '1046' ? 'Equipment Financing' : 'Inventory Financing',
    amount: id === '1046' ? 'RM 25,000' : 'RM 50,000',
    duration: id === '1046' ? '6 months' : '9 months',
    contractType: id === '1046' ? 'Ijarah (Leasing)' : 'Murabahah (Cost-Plus)',
    rating: id === '1046' ? 'Low Risk (A)' : 'Medium Risk (B)',
    profitRate: id === '1046' ? '12% p.a.' : '16% p.a.'
  };
  const handleApprove = () => {
    setComplianceStatus('approved');
    setShowConfirmation(true);
  };
  const handleReject = () => {
    setComplianceStatus('rejected');
    setShowConfirmation(true);
  };
  const handleConfirmationClose = () => {
    navigate('/dashboard/shariah');
  };
  if (showConfirmation) {
    return <div className="min-h-screen bg-neutral-50 flex flex-col justify-center items-center p-4" data-id="element-3277">
        <div className="w-full max-w-md" data-id="element-3278">
          <Card data-id="element-3279">
            <div className="text-center mb-6" data-id="element-3280">
              <div className="flex justify-center mb-4" data-id="element-3281">
                <div className={`w-16 h-16 rounded-full ${complianceStatus === 'approved' ? 'bg-success bg-opacity-10' : 'bg-error bg-opacity-10'} flex items-center justify-center`} data-id="element-3282">
                  {complianceStatus === 'approved' ? <CheckCircleIcon className="w-8 h-8 text-success" data-id="element-3283" /> : <XIcon className="w-8 h-8 text-error" data-id="element-3284" />}
                </div>
              </div>
              <h2 className="text-xl font-bold text-secondary" data-id="element-3285">
                {complianceStatus === 'approved' ? 'Shariah Compliance Approved!' : 'Application Returned for Revision'}
              </h2>
              <p className="text-neutral-500 mt-2" data-id="element-3286">
                {complianceStatus === 'approved' ? 'The micro-sukuk application has been certified as Shariah-compliant and contract documents have been generated.' : 'The application requires amendments to meet Shariah compliance standards.'}
              </p>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg mb-6" data-id="element-3287">
              <div className="flex items-center justify-between mb-3" data-id="element-3288">
                <h3 className="font-medium" data-id="element-3289">Application Details</h3>
                <span className={`${complianceStatus === 'approved' ? 'bg-success bg-opacity-10 text-success' : 'bg-error bg-opacity-10 text-error'} px-2 py-1 rounded-full text-xs font-medium`} data-id="element-3290">
                  {complianceStatus === 'approved' ? 'Approved' : 'Requires Revision'}
                </span>
              </div>
              <div className="space-y-2 text-sm" data-id="element-3291">
                <div className="flex justify-between" data-id="element-3292">
                  <span className="text-neutral-400" data-id="element-3293">Business</span>
                  <span className="font-medium" data-id="element-3294">
                    {applicationData.business}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3295">
                  <span className="text-neutral-400" data-id="element-3296">ID</span>
                  <span className="font-medium" data-id="element-3297">{applicationData.id}</span>
                </div>
                <div className="flex justify-between" data-id="element-3298">
                  <span className="text-neutral-400" data-id="element-3299">Contract Type</span>
                  <span className="font-medium" data-id="element-3300">
                    {applicationData.contractType}
                  </span>
                </div>
              </div>
            </div>
            {complianceStatus === 'approved' && <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-4 mb-6" data-id="element-3301">
                <div className="flex items-center" data-id="element-3302">
                  <InfoIcon className="w-5 h-5 text-primary mr-2 flex-shrink-0" data-id="element-3303" />
                  <p className="text-sm" data-id="element-3304">
                    Contract documents have been generated and sent to the MSME
                    for digital signing. You'll be notified once the contract is
                    signed.
                  </p>
                </div>
              </div>}
            {complianceStatus === 'rejected' && <div className="bg-error bg-opacity-5 border border-error border-opacity-20 rounded-lg p-4 mb-6" data-id="element-3305">
                <div className="flex items-center" data-id="element-3306">
                  <AlertCircleIcon className="w-5 h-5 text-error mr-2 flex-shrink-0" data-id="element-3307" />
                  <p className="text-sm" data-id="element-3308">
                    Feedback has been sent to the Digital Advisor to address the
                    compliance issues. They will work with the MSME to make the
                    necessary amendments.
                  </p>
                </div>
              </div>}
            <div className="flex justify-center" data-id="element-3309">
              <Button variant="primary" onClick={handleConfirmationClose} data-id="element-3310">
                Return to Dashboard
              </Button>
            </div>
          </Card>
        </div>
      </div>;
  }
  return <div className="max-w-4xl mx-auto" data-id="element-3311">
      <div className="mb-6" data-id="element-3312">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-3313">
          Shariah Compliance Review
        </h1>
        <p className="text-neutral-400" data-id="element-3314">
          Review and validate the micro-sukuk structure for Shariah compliance
        </p>
      </div>
      {/* Application Overview */}
      <section className="mb-8" data-id="element-3315">
        <Card data-id="element-3316">
          <div className="flex items-center mb-6" data-id="element-3317">
            <div className="w-12 h-12 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-4" data-id="element-3318">
              <FileTextIcon className="w-6 h-6 text-secondary" data-id="element-3319" />
            </div>
            <div data-id="element-3320">
              <h3 className="font-bold text-lg" data-id="element-3321">{applicationData.id}</h3>
              <div className="flex items-center text-sm text-neutral-400" data-id="element-3322">
                <span data-id="element-3323">{applicationData.business}</span>
                <span className="mx-2" data-id="element-3324">•</span>
                <span data-id="element-3325">{applicationData.type}</span>
                <span className="mx-2" data-id="element-3326">•</span>
                <span data-id="element-3327">{applicationData.amount}</span>
              </div>
            </div>
            <div className="ml-auto bg-warning bg-opacity-10 text-warning px-3 py-1 rounded-full text-sm font-medium" data-id="element-3328">
              Pending Shariah Review
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3329">
            <div data-id="element-3330">
              <h4 className="font-medium mb-3" data-id="element-3331">Application Details</h4>
              <div className="space-y-3" data-id="element-3332">
                <div className="flex justify-between" data-id="element-3333">
                  <span className="text-sm text-neutral-400" data-id="element-3334">Business</span>
                  <span className="text-sm font-medium" data-id="element-3335">
                    {applicationData.business}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3336">
                  <span className="text-sm text-neutral-400" data-id="element-3337">
                    Structure Type
                  </span>
                  <span className="text-sm font-medium" data-id="element-3338">
                    {applicationData.type}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3339">
                  <span className="text-sm text-neutral-400" data-id="element-3340">Amount</span>
                  <span className="text-sm font-medium" data-id="element-3341">
                    {applicationData.amount}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3342">
                  <span className="text-sm text-neutral-400" data-id="element-3343">Duration</span>
                  <span className="text-sm font-medium" data-id="element-3344">
                    {applicationData.duration}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3345">
                  <span className="text-sm text-neutral-400" data-id="element-3346">Risk Rating</span>
                  <span className="text-sm font-medium" data-id="element-3347">
                    {applicationData.rating}
                  </span>
                </div>
              </div>
            </div>
            <div data-id="element-3348">
              <h4 className="font-medium mb-3" data-id="element-3349">Contract Information</h4>
              <div className="space-y-3" data-id="element-3350">
                <div className="flex justify-between" data-id="element-3351">
                  <span className="text-sm text-neutral-400" data-id="element-3352">
                    Contract Type
                  </span>
                  <span className="text-sm font-medium" data-id="element-3353">
                    {applicationData.contractType}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3354">
                  <span className="text-sm text-neutral-400" data-id="element-3355">Profit Rate</span>
                  <span className="text-sm font-medium" data-id="element-3356">
                    {applicationData.profitRate}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3357">
                  <span className="text-sm text-neutral-400" data-id="element-3358">
                    Asset Ownership
                  </span>
                  <span className="text-sm font-medium" data-id="element-3359">
                    Transfer at end of term
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3360">
                  <span className="text-sm text-neutral-400" data-id="element-3361">
                    Payment Schedule
                  </span>
                  <span className="text-sm font-medium" data-id="element-3362">Monthly</span>
                </div>
                <div className="flex justify-between" data-id="element-3363">
                  <span className="text-sm text-neutral-400" data-id="element-3364">
                    Early Settlement
                  </span>
                  <span className="text-sm font-medium" data-id="element-3365">
                    Allowed with rebate
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Review Tabs */}
      <section className="mb-6" data-id="element-3366">
        <div className="border-b border-neutral-200" data-id="element-3367">
          <div className="flex overflow-x-auto -mb-px" data-id="element-3368">
            <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${selectedTab === 'contract' ? 'border-b-2 border-secondary text-secondary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setSelectedTab('contract')} data-id="element-3369">
              Contract Structure
            </button>
            <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${selectedTab === 'compliance' ? 'border-b-2 border-secondary text-secondary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setSelectedTab('compliance')} data-id="element-3370">
              Compliance Checklist
            </button>
            <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${selectedTab === 'documents' ? 'border-b-2 border-secondary text-secondary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setSelectedTab('documents')} data-id="element-3371">
              Contract Documents
            </button>
          </div>
        </div>
      </section>
      {/* Tab Content */}
      {selectedTab === 'contract' && <section className="mb-8" data-id="element-3372">
          <Card data-id="element-3373">
            <h3 className="font-bold text-lg mb-4" data-id="element-3374">
              Contract Structure Analysis
            </h3>
            <div className="mb-6" data-id="element-3375">
              <div className="flex items-center mb-3" data-id="element-3376">
                <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3377">
                  <BookOpenIcon className="w-5 h-5 text-secondary" data-id="element-3378" />
                </div>
                <div data-id="element-3379">
                  <h4 className="font-medium" data-id="element-3380">
                    {applicationData.contractType}
                  </h4>
                  <p className="text-sm text-neutral-400" data-id="element-3381">
                    {applicationData.contractType === 'Ijarah (Leasing)' ? 'Asset leasing with ownership transfer at the end of term' : 'Cost-plus financing structure for inventory purchase'}
                  </p>
                </div>
              </div>
              <div className="bg-neutral-50 p-4 rounded-lg mb-4" data-id="element-3382">
                <h5 className="font-medium mb-2" data-id="element-3383">Contract Flow</h5>
                <ol className="space-y-3 text-sm" data-id="element-3384">
                  {applicationData.contractType === 'Ijarah (Leasing)' ? <>
                      <li className="flex items-start" data-id="element-3385">
                        <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3386">
                          <span className="text-white text-xs" data-id="element-3387">1</span>
                        </div>
                        <div data-id="element-3388">
                          <span className="font-medium" data-id="element-3389">Purchase of Asset</span>
                          <p className="text-neutral-500" data-id="element-3390">
                            Platform purchases the espresso machine from the
                            approved vendor
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-3391">
                        <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3392">
                          <span className="text-white text-xs" data-id="element-3393">2</span>
                        </div>
                        <div data-id="element-3394">
                          <span className="font-medium" data-id="element-3395">Lease Agreement</span>
                          <p className="text-neutral-500" data-id="element-3396">
                            Asset is leased to Amani Cafe for the agreed term (6
                            months)
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-3397">
                        <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3398">
                          <span className="text-white text-xs" data-id="element-3399">3</span>
                        </div>
                        <div data-id="element-3400">
                          <span className="font-medium" data-id="element-3401">Lease Payments</span>
                          <p className="text-neutral-500" data-id="element-3402">
                            Monthly lease payments include capital recovery and
                            profit portion
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-3403">
                        <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3404">
                          <span className="text-white text-xs" data-id="element-3405">4</span>
                        </div>
                        <div data-id="element-3406">
                          <span className="font-medium" data-id="element-3407">
                            Ownership Transfer
                          </span>
                          <p className="text-neutral-500" data-id="element-3408">
                            At the end of lease term, ownership is transferred
                            to Amani Cafe
                          </p>
                        </div>
                      </li>
                    </> : <>
                      <li className="flex items-start" data-id="element-3409">
                        <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3410">
                          <span className="text-white text-xs" data-id="element-3411">1</span>
                        </div>
                        <div data-id="element-3412">
                          <span className="font-medium" data-id="element-3413">
                            Purchase Agreement
                          </span>
                          <p className="text-neutral-500" data-id="element-3414">
                            Platform agrees to purchase inventory on behalf of
                            GreenTech Solutions
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-3415">
                        <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3416">
                          <span className="text-white text-xs" data-id="element-3417">2</span>
                        </div>
                        <div data-id="element-3418">
                          <span className="font-medium" data-id="element-3419">Cost-Plus Sale</span>
                          <p className="text-neutral-500" data-id="element-3420">
                            Platform sells inventory to GreenTech Solutions at
                            cost plus declared profit
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-3421">
                        <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3422">
                          <span className="text-white text-xs" data-id="element-3423">3</span>
                        </div>
                        <div data-id="element-3424">
                          <span className="font-medium" data-id="element-3425">Deferred Payment</span>
                          <p className="text-neutral-500" data-id="element-3426">
                            GreenTech Solutions pays in installments over 9
                            months
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-3427">
                        <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3428">
                          <span className="text-white text-xs" data-id="element-3429">4</span>
                        </div>
                        <div data-id="element-3430">
                          <span className="font-medium" data-id="element-3431">
                            Immediate Ownership
                          </span>
                          <p className="text-neutral-500" data-id="element-3432">
                            Inventory ownership transfers to GreenTech Solutions
                            upon contract execution
                          </p>
                        </div>
                      </li>
                    </>}
                </ol>
              </div>
              <div className="bg-secondary bg-opacity-5 border border-secondary border-opacity-20 rounded-lg p-4 mb-4" data-id="element-3433">
                <div className="flex items-start" data-id="element-3434">
                  <ShieldIcon className="w-5 h-5 text-secondary mr-2 mt-0.5 flex-shrink-0" data-id="element-3435" />
                  <div data-id="element-3436">
                    <h5 className="text-sm font-medium text-secondary mb-1" data-id="element-3437">
                      Shariah Considerations
                    </h5>
                    <p className="text-sm text-neutral-500 mb-2" data-id="element-3438">
                      {applicationData.contractType === 'Ijarah (Leasing)' ? 'For Ijarah contracts, the lessor must own the asset throughout the lease period and bear ownership risks. The asset must be clearly identified and usable for its intended purpose.' : 'For Murabahah contracts, the seller must own the goods before selling them to the buyer. The cost price and markup must be clearly disclosed to the buyer.'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-4" data-id="element-3439">
              <div data-id="element-3440">
                <label className="block text-sm font-medium mb-2" data-id="element-3441">
                  Contract Structure Assessment
                </label>
                <select className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-secondary focus:border-secondary" data-id="element-3442">
                  <option value="" data-id="element-3443">Select assessment</option>
                  <option value="compliant" data-id="element-3444">
                    Compliant with Shariah principles
                  </option>
                  <option value="minor" data-id="element-3445">Minor adjustments required</option>
                  <option value="major" data-id="element-3446">Major revision required</option>
                  <option value="non-compliant" data-id="element-3447">
                    Non-compliant with Shariah principles
                  </option>
                </select>
              </div>
              <div data-id="element-3448">
                <label className="block text-sm font-medium mb-2" data-id="element-3449">
                  Comments and Recommendations
                </label>
                <textarea className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-secondary focus:border-secondary" rows={4} placeholder="Enter your assessment notes and recommendations..." defaultValue={applicationData.contractType === 'Ijarah (Leasing)' ? 'The Ijarah structure for equipment financing is appropriate. The contract clearly specifies that ownership risk remains with the lessor during the lease period. The maintenance responsibilities are properly allocated. The contract includes appropriate provisions for equipment defects and repair obligations.' : 'The Murabahah structure appears sound. The cost price and profit markup are clearly disclosed. The contract includes a provision for the platform to take ownership of the inventory before selling to the MSME. Recommend clarifying the exact timing of ownership transfer to ensure Shariah compliance.'} data-id="element-3450"></textarea>
              </div>
            </div>
          </Card>
        </section>}
      {selectedTab === 'compliance' && <section className="mb-8" data-id="element-3451">
          <Card data-id="element-3452">
            <h3 className="font-bold text-lg mb-4" data-id="element-3453">
              Shariah Compliance Checklist
            </h3>
            <div className="space-y-4 mb-6" data-id="element-3454">
              <div className="border border-neutral-200 rounded-lg" data-id="element-3455">
                <div className="p-4 border-b border-neutral-200" data-id="element-3456">
                  <div className="flex items-center justify-between" data-id="element-3457">
                    <h4 className="font-medium" data-id="element-3458">1. Interest (Riba)</h4>
                    <div className="flex space-x-2" data-id="element-3459">
                      <button className="px-3 py-1 rounded-full bg-success bg-opacity-10 text-success text-sm font-medium" data-id="element-3460">
                        Compliant
                      </button>
                      <button className="px-3 py-1 rounded-full bg-neutral-100 text-neutral-400 text-sm" data-id="element-3461">
                        Non-Compliant
                      </button>
                    </div>
                  </div>
                </div>
                <div className="p-4" data-id="element-3462">
                  <p className="text-sm mb-3" data-id="element-3463">
                    Ensure the contract is free from any interest-based
                    elements. The profit must be tied to the underlying asset or
                    business activity, not to the time value of money.
                  </p>
                  <div className="flex items-center" data-id="element-3464">
                    <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3465" />
                    <span className="text-sm" data-id="element-3466">
                      {applicationData.contractType === 'Ijarah (Leasing)' ? 'Profit is derived from the usufruct of the leased asset, not from the loan of money' : 'Profit is derived from the sale of goods with a markup, not from the loan of money'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="border border-neutral-200 rounded-lg" data-id="element-3467">
                <div className="p-4 border-b border-neutral-200" data-id="element-3468">
                  <div className="flex items-center justify-between" data-id="element-3469">
                    <h4 className="font-medium" data-id="element-3470">2. Uncertainty (Gharar)</h4>
                    <div className="flex space-x-2" data-id="element-3471">
                      <button className="px-3 py-1 rounded-full bg-success bg-opacity-10 text-success text-sm font-medium" data-id="element-3472">
                        Compliant
                      </button>
                      <button className="px-3 py-1 rounded-full bg-neutral-100 text-neutral-400 text-sm" data-id="element-3473">
                        Non-Compliant
                      </button>
                    </div>
                  </div>
                </div>
                <div className="p-4" data-id="element-3474">
                  <p className="text-sm mb-3" data-id="element-3475">
                    Ensure the contract is free from excessive uncertainty. All
                    key terms must be clearly defined, including the asset
                    description, payment schedule, and obligations of both
                    parties.
                  </p>
                  <div className="flex items-center" data-id="element-3476">
                    <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3477" />
                    <span className="text-sm" data-id="element-3478">
                      {applicationData.contractType === 'Ijarah (Leasing)' ? 'Asset is clearly specified (professional espresso machine), lease term and payments are clearly defined' : 'Inventory items are clearly specified, cost price, markup, and payment schedule are clearly defined'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="border border-neutral-200 rounded-lg" data-id="element-3479">
                <div className="p-4 border-b border-neutral-200" data-id="element-3480">
                  <div className="flex items-center justify-between" data-id="element-3481">
                    <h4 className="font-medium" data-id="element-3482">
                      3. Underlying Asset/Activity
                    </h4>
                    <div className="flex space-x-2" data-id="element-3483">
                      <button className="px-3 py-1 rounded-full bg-success bg-opacity-10 text-success text-sm font-medium" data-id="element-3484">
                        Compliant
                      </button>
                      <button className="px-3 py-1 rounded-full bg-neutral-100 text-neutral-400 text-sm" data-id="element-3485">
                        Non-Compliant
                      </button>
                    </div>
                  </div>
                </div>
                <div className="p-4" data-id="element-3486">
                  <p className="text-sm mb-3" data-id="element-3487">
                    Ensure the underlying asset or business activity is halal
                    (permissible). The financing must not be used for prohibited
                    goods or services.
                  </p>
                  <div className="flex items-center" data-id="element-3488">
                    <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3489" />
                    <span className="text-sm" data-id="element-3490">
                      {applicationData.contractType === 'Ijarah (Leasing)' ? 'Coffee equipment is halal and will be used for a permissible business activity' : 'Eco-friendly products are halal and will be used for a permissible business activity'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="border border-neutral-200 rounded-lg" data-id="element-3491">
                <div className="p-4 border-b border-neutral-200" data-id="element-3492">
                  <div className="flex items-center justify-between" data-id="element-3493">
                    <h4 className="font-medium" data-id="element-3494">4. Ownership and Transfer</h4>
                    <div className="flex space-x-2" data-id="element-3495">
                      <button className="px-3 py-1 rounded-full bg-success bg-opacity-10 text-success text-sm font-medium" data-id="element-3496">
                        Compliant
                      </button>
                      <button className="px-3 py-1 rounded-full bg-neutral-100 text-neutral-400 text-sm" data-id="element-3497">
                        Non-Compliant
                      </button>
                    </div>
                  </div>
                </div>
                <div className="p-4" data-id="element-3498">
                  <p className="text-sm mb-3" data-id="element-3499">
                    Ensure the ownership and transfer mechanisms are clearly
                    defined and compliant with Shariah principles.
                  </p>
                  <div className="flex items-center" data-id="element-3500">
                    <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3501" />
                    <span className="text-sm" data-id="element-3502">
                      {applicationData.contractType === 'Ijarah (Leasing)' ? 'Platform maintains ownership during lease period, with transfer mechanism at end of term' : 'Platform takes ownership of inventory before selling to the MSME, with immediate transfer upon contract execution'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="border border-neutral-200 rounded-lg" data-id="element-3503">
                <div className="p-4 border-b border-neutral-200" data-id="element-3504">
                  <div className="flex items-center justify-between" data-id="element-3505">
                    <h4 className="font-medium" data-id="element-3506">5. Risk and Responsibility</h4>
                    <div className="flex space-x-2" data-id="element-3507">
                      <button className="px-3 py-1 rounded-full bg-warning bg-opacity-10 text-warning text-sm font-medium" data-id="element-3508">
                        Review Required
                      </button>
                      <button className="px-3 py-1 rounded-full bg-neutral-100 text-neutral-400 text-sm" data-id="element-3509">
                        Non-Compliant
                      </button>
                    </div>
                  </div>
                </div>
                <div className="p-4" data-id="element-3510">
                  <p className="text-sm mb-3" data-id="element-3511">
                    Ensure appropriate allocation of risks and responsibilities
                    between the parties.
                  </p>
                  <div className="flex items-start" data-id="element-3512">
                    <AlertCircleIcon className="w-5 h-5 text-warning mr-2 mt-0.5" data-id="element-3513" />
                    <span className="text-sm" data-id="element-3514">
                      {applicationData.contractType === 'Ijarah (Leasing)' ? 'Need to clarify responsibility for major maintenance and insurance during lease period' : 'Need to clarify responsibility for inventory quality and condition upon delivery'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-3515">
              <label className="block text-sm font-medium mb-2" data-id="element-3516">
                Overall Compliance Assessment
              </label>
              <textarea className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-secondary focus:border-secondary" rows={3} placeholder="Enter your overall assessment..." defaultValue="The contract structure is generally compliant with Shariah principles. The profit mechanism is appropriately tied to the underlying asset/business activity rather than time value of money. One area requiring clarification is the allocation of risk and responsibility as noted in item #5 above. Recommend adding a clause to address this before final approval." data-id="element-3517"></textarea>
            </div>
          </Card>
        </section>}
      {selectedTab === 'documents' && <section className="mb-8" data-id="element-3518">
          <Card data-id="element-3519">
            <h3 className="font-bold text-lg mb-4" data-id="element-3520">Contract Documents</h3>
            <div className="space-y-4 mb-6" data-id="element-3521">
              <div className="border border-neutral-200 rounded-lg p-4" data-id="element-3522">
                <div className="flex items-center mb-3" data-id="element-3523">
                  <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3524">
                    <FileTextIcon2 className="w-5 h-5 text-secondary" data-id="element-3525" />
                  </div>
                  <div className="flex-1" data-id="element-3526">
                    <h4 className="font-medium" data-id="element-3527">Main Contract Agreement</h4>
                    <p className="text-sm text-neutral-400" data-id="element-3528">
                      {applicationData.contractType === 'Ijarah (Leasing)' ? 'Ijarah agreement with purchase undertaking' : 'Murabahah purchase agreement'}
                    </p>
                  </div>
                  <Button variant="outline" size="sm" data-id="element-3529">
                    Preview
                  </Button>
                </div>
                <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-3530">
                  <h5 className="text-sm font-medium mb-2" data-id="element-3531">
                    Key Contract Clauses
                  </h5>
                  <ul className="space-y-2 text-sm" data-id="element-3532">
                    <li className="flex items-start" data-id="element-3533">
                      <CheckIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-3534" />
                      <span data-id="element-3535">
                        {applicationData.contractType === 'Ijarah (Leasing)' ? 'Lease term and payment schedule' : 'Cost price and markup disclosure'}
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-3536">
                      <CheckIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-3537" />
                      <span data-id="element-3538">
                        {applicationData.contractType === 'Ijarah (Leasing)' ? 'Asset specifications and delivery terms' : 'Inventory specifications and delivery terms'}
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-3539">
                      <CheckIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-3540" />
                      <span data-id="element-3541">
                        {applicationData.contractType === 'Ijarah (Leasing)' ? 'Maintenance responsibilities' : 'Payment terms and schedule'}
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-3542">
                      <CheckIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-3543" />
                      <span data-id="element-3544">
                        {applicationData.contractType === 'Ijarah (Leasing)' ? 'Ownership transfer mechanism' : 'Ownership transfer clause'}
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-3545">
                      <CheckIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-3546" />
                      <span data-id="element-3547">Early settlement terms and rebate calculation</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="border border-neutral-200 rounded-lg p-4" data-id="element-3548">
                <div className="flex items-center mb-3" data-id="element-3549">
                  <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3550">
                    <ClipboardCheckIcon className="w-5 h-5 text-secondary" data-id="element-3551" />
                  </div>
                  <div className="flex-1" data-id="element-3552">
                    <h4 className="font-medium" data-id="element-3553">
                      Shariah Compliance Certificate
                    </h4>
                    <p className="text-sm text-neutral-400" data-id="element-3554">
                      Official certification of Shariah compliance
                    </p>
                  </div>
                  <Button variant="outline" size="sm" data-id="element-3555">
                    Preview
                  </Button>
                </div>
              </div>
              <div className="border border-neutral-200 rounded-lg p-4" data-id="element-3556">
                <div className="flex items-center mb-3" data-id="element-3557">
                  <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3558">
                    <FileTextIcon2 className="w-5 h-5 text-secondary" data-id="element-3559" />
                  </div>
                  <div className="flex-1" data-id="element-3560">
                    <h4 className="font-medium" data-id="element-3561">Payment Schedule</h4>
                    <p className="text-sm text-neutral-400" data-id="element-3562">
                      Detailed payment breakdown with due dates
                    </p>
                  </div>
                  <Button variant="outline" size="sm" data-id="element-3563">
                    Preview
                  </Button>
                </div>
              </div>
            </div>
            <div className="bg-secondary bg-opacity-5 border border-secondary border-opacity-20 rounded-lg p-4 mb-6" data-id="element-3564">
              <div className="flex items-center mb-2" data-id="element-3565">
                <InfoIcon className="w-5 h-5 text-secondary mr-2" data-id="element-3566" />
                <h4 className="font-medium text-secondary" data-id="element-3567">
                  Document Generation
                </h4>
              </div>
              <p className="text-sm text-neutral-500 mb-3" data-id="element-3568">
                Upon approval of Shariah compliance, these documents will be
                automatically generated and sent to the MSME for digital
                signing. The contract will be legally binding once signed by all
                parties.
              </p>
              <div className="flex items-center text-sm text-secondary" data-id="element-3569">
                <CheckIcon className="w-4 h-4 mr-1" data-id="element-3570" />
                <span data-id="element-3571">
                  Documents will be securely stored on the secure vault for
                  immutability and auditability
                </span>
              </div>
            </div>
            <div data-id="element-3572">
              <label className="block text-sm font-medium mb-2" data-id="element-3573">
                Document Review Notes
              </label>
              <textarea className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-secondary focus:border-secondary" rows={3} placeholder="Enter your notes about the contract documents..." defaultValue="The contract documents are well-structured and contain all necessary Shariah-compliant provisions. The payment schedule clearly separates the principal and profit components. Recommend adding a clause regarding insurance responsibility for the leased equipment before final approval." data-id="element-3574"></textarea>
            </div>
          </Card>
        </section>}
      {/* Action Buttons */}
      <section className="mb-8" data-id="element-3575">
        <Card data-id="element-3576">
          <h3 className="font-bold text-lg mb-4" data-id="element-3577">
            Shariah Compliance Decision
          </h3>
          <div className="mb-4" data-id="element-3578">
            <label className="block text-sm font-medium mb-2" data-id="element-3579">
              Final Assessment Comments
            </label>
            <textarea className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-secondary focus:border-secondary" rows={3} placeholder="Enter your final assessment and recommendations..." defaultValue={`The ${applicationData.contractType} structure for ${applicationData.business} is generally compliant with Shariah principles. The contract clearly defines the asset, payment terms, and ownership transfer mechanism. One minor issue requires clarification: the responsibility for major maintenance and insurance during the lease period. Recommend adding a clause to address this before final approval.`} data-id="element-3580"></textarea>
          </div>
          <div className="flex flex-col sm:flex-row justify-end gap-3" data-id="element-3581">
            <Button variant="outline" className="border-error text-error" onClick={handleReject} data-id="element-3582">
              Return for Revision
            </Button>
            <Button variant="outline" className="border-neutral-300 text-neutral-500" data-id="element-3583">
              Save Draft
            </Button>
            <Button variant="secondary" icon={<ArrowRightIcon className="w-4 h-4" data-id="element-3585" />} iconPosition="right" onClick={handleApprove} data-id="element-3584">
              Approve & Generate Contracts
            </Button>
          </div>
        </Card>
      </section>
    </div>;
};
export default ShariahReviewPage;